import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import {
    selectCorporateArtCollectionsData,
    selectCorporateArtCollectionsStatus,
    selectCorporateArtCollectionsError,
    initializeAsync,
} from "./corporateArtCollectionsSlice";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import { ArtCollection } from "../../components/ArtCollection";
import { useLocation } from "react-router-dom";
import { get, post } from "../../api";
import InfiniteScroll from "react-infinite-scroll-component";

// Add custom imports here

const CorporateArtCollections = () => {
    const data = useSelector(selectCorporateArtCollectionsData);
    const status = useSelector(selectCorporateArtCollectionsStatus);
    const error = useSelector(selectCorporateArtCollectionsError);
    const dispatch = useDispatch();
    const location = useLocation();

    const [hasImages, setHasImages] = useState(true);
    const [itemData, setItemData] = useState();
    const [loading, setLoading] = useState(true);
    const [noRecordFound, setNoRecordFound] = useState(false);

    const photosRef = useRef([]);
    const hasMoreRef = useRef(true);
    const lastKeyRef = useRef();
    const initiatedCallRef = useRef(false);

    let title = "INSTALLATION COLLECTION";
    let page = "Corporate";

    useEffect(() => {
        loadData("");
    }, [location.pathname]);

    const loadData = (lastKey) => {
        if (hasMoreRef.current && !initiatedCallRef.current) {
            initiatedCallRef.current = true;
            setNoRecordFound(false);
            post("artLocation/getLocationRecords", { lastKey: lastKey, caching: "yes" }).then((result) => {
                if (result.isSuccess) {
                    processData(result.data.records);
                    if (result.data.lastKey) {
                        hasMoreRef.current = true;
                        lastKeyRef.current = result.data.lastKey;
                    } else {
                        hasMoreRef.current = false;
                    }
                    if (photosRef.current?.length === 0) {
                        setNoRecordFound(true);
                    }
                }
                if (loading) {
                    setLoading(false);
                }
                initiatedCallRef.current = false;
            });
        }
    };

    const processData = (data) => {
        if (data.length > 0) {
            let images = data?.map((item) => {
                return {
                    img:
                        process.env.REACT_APP_CLOUD_FRONT_URL +
                        (item.publishedAssetLink?.asset?.thumbnail
                            ? item.publishedAssetLink?.asset?.thumbnail
                            : item.publishedAssetLink?.asset?.fileId),
                    originalImg: process.env.REACT_APP_CLOUD_FRONT_URL + item.publishedAssetLink?.asset?.fileId,
                    title: item.name,
                    companyName: item.companyName,
                };
            });
            photosRef.current = [...photosRef.current, ...images];
            setItemData([...photosRef.current, ...images]);
            setHasImages(true);
        }
    };

    const fetchData = () => {
        loadData(lastKeyRef.current);
    };

    let body = (
        <Container sx={{ background: "black", minHeight: "100vh", pt: "0px" }} maxWidth={false} disableGutters>
            <main>
                <Box
                    sx={{
                        bgcolor: "#000",
                        color: "white",
                    }}>
                    {hasImages ? (
                        <div id="scrollableDiv" style={{ height: "100vh", overflow: "auto", width: "100vw" }}>
                            <InfiniteScroll
                                dataLength={photosRef.current.length} //This is important field to render the next data
                                next={fetchData}
                                hasMore={true}
                                loader={<h5></h5>}
                                height={"100vh"}
                                endMessage={<p></p>}>
                                <ArtCollection
                                    page={page}
                                    title={title}
                                    noRecordFound={noRecordFound}
                                    photos={photosRef.current}
                                    subtitle={
                                        <>
                                            A curated gallery of{" "}
                                            <span
                                                style={{
                                                    fontFamily: "Stakkat, sans-serif",
                                                    fontStyle: "italic",
                                                }}>
                                                our corporate and nonprofit installations
                                            </span>{" "}
                                            throughout the country.
                                        </>
                                    }></ArtCollection>
                            </InfiniteScroll>
                        </div>
                    ) : (
                        <></>
                    )}
                    {/* <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                        <CircularProgress color="inherit" />
                    </Backdrop> */}
                </Box>
            </main>
        </Container>
    );

    return getPageContent(body, status, error);
};

export { CorporateArtCollections };
